module.exports = __webpack_public_path__ + "static/media/torn-v.6c03c034.svg";